import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import path from "path";
import { useContext } from "react";
import config from "../config";
import { ApiProvider, Context } from "./ApiContext"; // models

import initNeighbourhoods from "./resources/neighbourhoods";
import initPackages from "./resources/packages";
import initLots from "./resources/lots";
import initTownhomes from "./resources/townhomes";
import initFiltersOptions from "./resources/filters";
import initBuildings from "./resources/buildings";
export var Api = ApiProvider;
var PROJECT_SLUG = config.get("api.project"),
    NB_SLUG = config.get("api.neighbourhood"),
    api = {};
export var useApi = function useApi() {
  var a = useContext(Context),
      b = _slicedToArray(a, 2),
      c = b[0],
      d = c.data,
      e = c.loading,
      f = c.error,
      g = b[1];

  if (!api.packageSearch) {
    api = {
      data: d,
      loading: e,
      error: f,
      refetch: g
    };
    var h = d || {},
        i = h.packageSearch,
        j = h.assetpath;
    api.current = {
      assetpath: j
    }, api.packageSearch = i;

    var k = function k(a) {
      return a ? 0 === a.indexOf("http") ? a.toString() : "".concat(j).concat(path.join("/", a)) : null;
    },
        l = function l(a, b) {
      var c = b.projectSlug,
          d = b.neighbourhoodSlug,
          e = a.slug || a.id,
          f = "hal" === a.propertyType ? "hl" : a.propertyType,
          g = f ? "".concat(f, "/") : "";
      return PROJECT_SLUG || NB_SLUG ? PROJECT_SLUG ? "".concat(g).concat(d, "/").concat(e) : "".concat(g).concat(e.toString()) : "".concat(g).concat(c, "/").concat(d, "/").concat(e);
    },
        m = {
      parseUrl: k,
      parseSlug: l
    }; //
    // api actions/filters
    //


    api.neighbourhoods = initNeighbourhoods(api, m), api.packages = initPackages(api, m), api.buildings = initBuildings(api, m), api.townhomes = initTownhomes(api, m), api.filters = initFiltersOptions(api, m), api.lots = initLots(api, m);
  }

  return api;
};
export default useApi;